import { fetchNumberOfUsers, MerchantHomeQuery } from "../../merchantHomeApi"
import { useMerchant } from "../../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { StatisticGraph } from "../../../../../../shared/components/statistic/StatisticGraph"

type StatisticsNumberOfUsersContentProps = Readonly<{
    periodInDays: number
}>

export function StatisticsNumberOfUsersContent({ periodInDays }: StatisticsNumberOfUsersContentProps) {
    const { merchantId } = useMerchant()

    const { data } = useApiQuery(fetchNumberOfUsers, {
        queryName: MerchantHomeQuery.STATISTICS_NUMBER_OF_USERS,
        dependencies: {
            merchantId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.numberOfUsers.map((entry) => entry.date)}
            datasets={data.numberOfUsers.map((entry) => entry.number)}
            title={data?.reportSummary?.numberOfUsers}
        />
    )
}
